import TransformComponent from '../../../Component/Transform';
import CardComponent, { DEFAULT_CARD_SCALE } from '../../../Component/Level/Card';
import Renderable from '../../../Component/Renderable';
import BaseCard from '../../../Prototype/Level/Card/BaseCard';
import CardStateHelper from '../../../State/Card/CardStateHelper';
import CardSystem from '../CardSystem';
import SpriteComponent from '../../../Component/Render/Sprite';
import { ICardsState } from '../../../State/Card/ICardState';
import Interactable from '../../../Component/Interactable';
import { getCardModifierHandler } from 'Prototype/Level/Card/ModifierTypeMap';
import { CardState } from 'Prototype/Level/Card/CardState';

export default class BaseCardHandler {
    public card: BaseCard;
    public transform: TransformComponent;
    public cardComponent: CardComponent;
    public renderable: Renderable;

    constructor(card: BaseCard) {
        this.card = card;

        this.transform = this.card.getComponent(TransformComponent);
        this.cardComponent = this.card.getComponent(CardComponent);
        this.renderable = this.card.getComponent(Renderable);
    }

    public handleStateChange(state: ICardsState, cardSystem: CardSystem) {
        // This removes the animation bugs,
        if (this.cardComponent.animating) return;

        const cardData = state.cards[this.card.id];

        // If reverted to state in which cardData is unavailable.
        if (!cardData) {
            this.renderable.visible = false;
            return;
        }

        this.cardComponent.faceUp = cardData.faceUp;
        this.setCardFaceUp(cardData.faceUp);
        this.cardComponent.attempts = cardData.attempts;
        this.cardComponent.currentState = CardStateHelper.getCardState(
            state,
            this.card.id
        );
        //this.renderable.visible = true;
        this.transform.scale.set(DEFAULT_CARD_SCALE);

        switch (CardStateHelper.getCardState(state, this.card.id)) {
            case CardState.IN_PLAY:
                this.handleCardInPlay(state, cardSystem);
                break;
            case CardState.IN_STACK:
                this.handleCardInStack(state, cardSystem);
                break;
            case CardState.FOLDED:
                this.handleCardFolded(state, cardSystem);
                break;
            case CardState.DISCARDED:
                this.handleCardDiscarded(state, cardSystem);
                break;
            case CardState.UNKNOWN:
                this.handleCardUnknown(state, cardSystem);
                break;
        }

        this.card.modifiers.forEach(modifier => {
            getCardModifierHandler(modifier).handleStateChange(state, cardSystem);
        })
    }

    public handleCardInPlay(state: ICardsState, cardSystem: CardSystem) {
        if (!cardSystem.cardsContainer.hasChild(this.card)) {
            cardSystem.cardsContainer.addChild(this.card);
        }
        this.transform.position.set(this.cardComponent.x, this.cardComponent.y);
        this.transform.rotation = this.cardComponent.rotation;

        this.renderable.visible = true;
    }

    public handleCardInStack(state: ICardsState, cardSystem: CardSystem) {
        if (!cardSystem.stackContainer.hasChild(this.card)) {
            cardSystem.stackContainer.addChild(this.card);
        }

        this.transform.rotation = 0;

        /*
        const cardsInStack = cardSystem.getCardsInStack();
        if (this.card !== cardsInStack[cardsInStack.length - 1]) {
            this.renderable.visible = false;
        }
        */
    }

    public handleCardFolded(state: ICardsState, cardSystem: CardSystem) {
        if (!cardSystem.stackContainer.hasChild(this.card)) {
            cardSystem.stackContainer.addChild(this.card);
        }
        this.transform.position.set(0);
        this.transform.rotation = 0;
        this.card.getComponent(Interactable).buttonMode = false;

        /*
        const cardsFolded = cardSystem.getCardsFolded();
        if (this.card !== cardsFolded[cardsFolded.length - 1]) {
            this.renderable.visible = false;
        }
        */
    }

    public handleCardDiscarded(state: ICardsState, cardSystem: CardSystem) {
        this.renderable.visible = false;
    }

    public handleCardUnknown(state: ICardsState, cardSystem: CardSystem) {
        this.renderable.visible = false;
    }

    public setCardFaceUp(faceUp: boolean) {
        this.card
            .getChildByName('cardFrontSprite')
            .getComponent(SpriteComponent).visible = faceUp;
        this.card
            .getChildByName('cardBackSprite')
            .getComponent(SpriteComponent).visible = !faceUp;
        this.card.updateModifiersVisibility(faceUp);
    }

    public setCardModifiersVisible(visible: boolean) {
        const modifierContainer = this.card.getChildByName('modifierContainer');
        if (modifierContainer) {
            modifierContainer.getComponent(Renderable).visible = visible;
        }
    }

    public clearModifiers() {
        this.card.modifiers.forEach((modifier) => {
            getCardModifierHandler(modifier).clearModifier();
        });
    }
}
